import { BaseRouterURL } from "./BaseRouterURL";
import { URLRegistry } from "./URLRegistry";

export class URLManager {
    static getRouter(type: string): BaseRouterURL {
        return URLRegistry.getRouter(type)
    }
}